export const validatePhoneNumber = (value) => {
  if (!value || !value.startsWith('+')) return true;

  const digitsOnly = value.replace(/\D/g, '');

  if (value.startsWith('+47')) {
    return digitsOnly.length === 10; // Norwegia : +47 + 8 cyfr
  }

  const validChars = /^[\d+()\- ]{11,17}$/;
  const hasEnoughDigits = digitsOnly.length >= 11;

  return validChars.test(value) && hasEnoughDigits;
};
